import {
  Box,
  BoxProps,
  Flex,
  FlexProps,
  HeadingProps,
  TextProps,
} from '@chakra-ui/react';
import { RecordAuditInfo } from '@monetize/types/common';
import React, { FunctionComponent as FC } from 'react';
import { MPageHeaderLeftSection } from './MPageHeaderLeftSection';

interface MPageHeaderProps {
  title?: string | React.ReactNode;
  id?: string;
  size?: HeadingProps['size'];
  tag?: React.ReactNode; // TODO: Rename tag prop to something generic
  tagStyle?: TextProps;
  subTitle?: React.ReactNode;
  hasBackButton?: boolean;
  children?: React.ReactNode;
  hideContent?: boolean;
  status?: string;
  migrated?: boolean;
  copyUrl?: string | boolean;
  containerProps?: BoxProps;
  parentLink?: string;
  parentLinkTitle?: string;
  /** Alternate react component for the id */
  customIdCopyBox?: React.ReactNode;
  /** Added after parent link and id with dividers between */
  extraSubtitleParts?: React.ReactNode[];
  renderLeftSection?: React.ReactNode;
  firstRowPlaceholder?: React.ReactNode;
  childrenProps?: Omit<FlexProps, 'alignItems' | 'as'>;
  recordAuditInfo?: RecordAuditInfo;
  entityJson?: Record<string, unknown>;
  extraBadges?: React.ReactNode[];
}

const MPageHeader: FC<MPageHeaderProps> = React.forwardRef<
  any,
  MPageHeaderProps
>(
  (
    {
      title = '',
      id = '',
      size = 'lg',
      tag = '',
      tagStyle,
      subTitle,
      hasBackButton = false,
      children = null,
      hideContent = false,
      status,
      migrated,
      copyUrl,
      containerProps,
      parentLink,
      parentLinkTitle,
      customIdCopyBox,
      extraSubtitleParts,
      renderLeftSection,
      firstRowPlaceholder,
      childrenProps,
      recordAuditInfo,
      entityJson,
      extraBadges,
    }: MPageHeaderProps,
    ref,
  ) => {
    if (hideContent) {
      return null;
    }
    return (
      <Box position="relative" w="100%" mb={4} {...containerProps}>
        <Flex justifyContent="space-between" flexWrap="wrap">
          <Box flex="1" minW="0">
            {renderLeftSection}
            {!renderLeftSection && (
              <MPageHeaderLeftSection
                hasBackButton={hasBackButton}
                size={size}
                title={title}
                tag={tag}
                tagStyle={tagStyle}
                parentLink={parentLink}
                parentLinkTitle={parentLinkTitle}
                id={id}
                copyUrl={copyUrl}
                recordAuditInfo={recordAuditInfo}
                customIdCopyBox={customIdCopyBox}
                extraSubtitleParts={extraSubtitleParts}
                subTitle={subTitle}
                status={status}
                migrated={migrated}
                firstRowPlaceholder={firstRowPlaceholder}
                entityJson={entityJson}
                extraBadges={extraBadges}
              />
            )}
          </Box>

          <Flex alignItems="center" {...childrenProps}>
            {children}
          </Flex>
        </Flex>
      </Box>
    );
  },
);

export default MPageHeader;
